import { ReactNode } from "react";

/**
 * Wrapping a view for background color is only a good idea on native where scrollers are nested
 */
const NativeBackgroundColorWrapper = ({ children }: { children?: ReactNode }) => {
	return <>{children}</>;
};
export default NativeBackgroundColorWrapper;
